<template>
  <!-- 图 按钮 title 首页  -->
  <!-- class="swiper-container" :style="{height: windowHeight+'px'}" -->
  <div>
    <!-- class="swiper-wrapper" -->
    <div>
      <!-- swiper-slide -->
      <div class="">
        <div class=" animated full lnviteFrom" ref="wrapper">
          <div class="logo">
            <img class="w-img" src="../../static/logo.png" alt="">
          </div>
          <button onClick="getLocation()" id="bbb"></button>
          <div v-if="toggle" class="logo-bottom">
            <img class="w-img" src="../../static/logo-bottom.png" alt="">
          </div>
          <div v-if="toggle" class="change-logo">
            <img src="../../static/change-logo1.png" alt="">
          </div>
          <div v-else class="change-logo">
            <img src="../../static/change-logo.png" alt="">
          </div>
          <div class="new-from">
            <p>
              <span class="from-icon"><img class="phone" src="../../static/phone.png" alt=""> </span>
              <input class="w-inp" id="www" v-model="newPhone" type="text" maxlength="11" placeholder="请输入手机号">
            </p>
            <p>
              <span class="from-icon"><img class="psd" src="../../static/yzm.png" alt=""></span>
              <input class="d-inp" type="number" placeholder="请输入验证码" maxlength="6" v-model="yzm">
              <button class="fs-btn" v-if='isSms===true' @click="fsYZM()">发送验证码</button>
              <button class="fs-btn" v-else>{{count}}后重新发送</button>
            </p>
            <!--<p v-show="citySelect">
                <span class="from-icon">
                  <img class="psd" src="../../static/map.png" alt="">
               </span>
              <input type="text" id="picker" placeholder="每次点击数据联动" readonly style="width: 85%!important;">
            </p>-->
            <!--<p>-->
            <!--<span class="from-icon">-->
            <!--<img class="psd" src="../../static/psd.png" alt="">-->
            <!--</span>-->
            <!--<input class="w-inp" type="password" placeholder="登录密码(8-16位数字/字母组合)" maxlength="12" minlength="6"-->
            <!--v-model="mPsd">-->
            <!--</p>-->
            <!--<button class="up-data" @click="goToZc">共青团临汾市委邀请您注册守护者</button>-->
            <button class="up-data" :disabled="disabled" @click="goToZc">注册守护者,避免孩子走失风险</button>
          </div>
          <i class="next-icon" @click="changeHTml()" style="visibility: hidden">
            <img class="w-img" src="../../static/next-icon.gif" alt="">
          </i>
        </div>
      </div>
      <!-- swiper-slide -->
      <div class="">
        <div class=" animated full Down " ref="two">
          <div class="video">
            <iframe src="https://v.qq.com/iframe/player.html?vid=h0533ld4vaf&tiny=0&auto=0" frameborder="0"></iframe>
            <!--<video src="https://v.qq.com/iframe/player.html?vid=h0533ld4vaf&tiny=0&auto=0" ></video>-->
          </div>
          <div class="Down-logo">
            <img src="../../static/down-logo.png" alt="">
            <img src="../../static/down-img-text.png" alt="">
          </div>
          <div class="down-txt-img">
            <p class="down-txt">孩子天性活泼，走失风险无处不在，请家长们关注孩子安全，正视孩子成长过程中的潜在风险！</p>

            <div class="">
              <button class="down-btn">
                下载APP  为孩子增加一份安全保障
                <i class="down-icon"></i>
                <a id="donw-a" @click="ifHasApp"></a>
                <!--:href=downUrl-->
                <!--  https://s.beta.myapp.com/myapp/rdmexp/exp/file/comzxkjccser_105_7a913a46-5f40-5d70-8a4e-5df3c148f1d6.apk -->
              </button>
            </div>

            <p class="down-img logo-two"><img src="../../static/logo-two.jpg" alt=""></p>

            <p class="down-img"><img src="../../static/overText.png" alt=""></p>
          </div>
        </div>
      </div>
    </div>
    <div id="allmap" style="visibility: hidden"></div>
  </div>


</template>
<script>
  export default {
    name: '',
    data() {
      return {
        toggle: true,// false 临汾
        test:false,//false 正式
        Title: '',
        isNum: /^1(3|4|5|6|7|8|9)\d{9}$/,
        phoneReg: /^(0|869|17951)?(13[0-9]|15[0-9]|17[0-9]|18[0-9]|14[0-9]16[0-9])[0-9]{8}$/,
        yzmReg: /^\d{6}$/,
        psdReg: /^[a-z0-9]{6,16}$/i,
        maxHeight: 0,
        changeClass: '',
        changeClass1: '',
        newPhone: '',
        isSms: true,
        count: 120,
        token: '',
        yzm: '',
        mPsd: '',
        inviteMid: 1,
        subMitToggle: true,
        sss: true,
        h: 0,
        hh: '',
        swiper: '',
        url: "https://api.crotg.com/app/",
//        url: "http://192.168.10.110/warningapp/",
        wxData: '',
        //title: '共青团临汾市委邀请您加入守护者',
        title: '',
        desc: '【守护者】为您的孩子提供一份安全保障.多一份守护,少一份意外!',
        imgUrl: 'http://crotg.com/duty/static/logo-icon.png',
        windowHeight: '',
        downUrl: '',
        mid:'',
        FAILBACK: {
          ANDROID: "https://android.myapp.com/myapp/detail.htm?apkName=com.zxkj.ccser",
          IOS: "https://itunes.apple.com/cn/app/%E5%AE%88%E6%8A%A4%E8%80%85%E9%A2%84%E8%AD%A6/id1343044544?mt=8",
          link: 'crotgscheme://',
          iosLink: 'CrotgScheme://',
        },
        citySelect:true,
        disabled:false
      }
    },
    mounted() {
      this.Details('0')
      //getCurLocation();
      function getCurLocation() {
        var options = {timeout: 9000};
        var geolocation = new qq.maps.Geolocation();
        geolocation.getLocation(function(position){
          localStorage.setItem('county',position.district);
          localStorage.setItem('province',position.province);
          localStorage.setItem('city',position.city);
          localStorage.setItem('latitude',position.lat);
          localStorage.setItem('longitude',position.lng);
        },function(){
          localStorage.setItem('city',"定位失败！");
        }, options);
        }

      if (this.toggle) {
        this.title = '儿童守着邀请您加入守护者'
      } else {
        this.title = '共青团临汾市委邀请您加入守护者'
      }
      if (this.test) {
        this.url="https://test.crotg.com/app/"
      } else {
        this.url="https://api.crotg.com/app/"

      }

      String.prototype.getQuery = function (name) {
        let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)'),
          r = this.replace(/#.*($)/gi, '').substr(this.indexOf('?') + 1).match(reg);
        return r ? decodeURIComponent(r[2]) : null;
      };

      this.inviteMid = window.location.href.getQuery('id');

      if (this.inviteMid === null) {
        this.inviteMid = 1;
      }

      this.wxShare();

      let wHei = document.body.clientHeight;

      this.windowHeight = document.documentElement.clientHeight;   //强制最外层的高度

      let fElem = null;

      this.hh = document.documentElement.clientHeight;

      this.h = document.documentElement.clientHeight;

      this.maxHeigh = document.documentElement.clientWidth;

      this.getToken();

      console.log(navigator.userAgent)
     /* if(localStorage.getItem('city') != '定位失败'){
        this.citySelect =true;
      }else{
        this.citySelect =false;
      }*/

    },
    methods: {
      Details(val){
        var _this = this;
        $.ajax({
          url:_this.url+'/memberShareDetails/addMemberShareDetails',
          type:'get',
          data:{
            mid:_this.GetQueryStringa('shareMid'),
            perMid:_this.GetQueryStringa('shareMid'),
            type:_this.GetQueryStringa('shareType'),
            behavior:val,
            value:_this.GetQueryStringa('value'),
          },
          success:function(res){
          }
        })
      },
      ifHasApp() {
        this.Details('5')
        let browser = {
          isAndroid: function () {
            return navigator.userAgent.match(/Android/i) ? true : false;
          },
          isMobileQQ: function () {
            let ua = navigator.userAgent;
            return /(iPad|iPhone|iPod).*? (IPad)?QQ\/([\d\.]+)/.test(ua) || /\bV1_AND_SQI?_([\d\.]+)(.*? QQ\/([\d\.]+))?/.test(ua);
          },
          isIOS: function () {
            return navigator.userAgent.match(/iPhone|iPad|iPod/i) ? true : false;
          },
          isWx: function () {
            return navigator.userAgent.match(/micromessenger/i) ? true : false;
          }
        };
        let ua = window.navigator.userAgent;
        let isAndroidChrome = (ua.match(/Chrome\/([\d.]+)/) || ua.match(/CriOS\/([\d.]+)/))
          && browser.isAndroid() && !browser.isMobileQQ();
        let iframe = document.createElement("iframe"), aLink = document.createElement("a"), body = document.body,
          loadTimer = null;

        if (browser.isWx() && browser.isAndroid()) {
          window.location.href = this.FAILBACK.ANDROID;
        }
        //
        else if (browser.isIOS()) {
          if (browser.isWx()) {
            window.location.href = this.FAILBACK.IOS;
          } else {
            aLink.href = this.FAILBACK.iosLink;
            body.appendChild(aLink);
            aLink.click();
          }
        }
        else if (isAndroidChrome) {
          aLink.href = this.FAILBACK.link;
          body.appendChild(aLink);
          aLink.click();
        }
        else {

          body.appendChild(iframe);
          iframe.src = this.FAILBACK.link;

        }

        let start = Date.now(),
          that = this;
        loadTimer = setTimeout(() => {

          if (document.hidden || document.webkitHidden) {
            return;
          }

          // 如果app启动，浏览器最小化进入后台，则计时器存在推迟或者变慢的问题
          // 那么代码执行到此处时，时间间隔必然大于设置的定时时间
          if (Date.now() - start > 3000 + 200) {
            // come back from app
            // 如果浏览器未因为app启动进入后台，则定时器会准时执行，故应该跳转到下载页
          } else {
            //微信里正常流程 不是微信里a标签直接跳转

            window.location.href = browser.isIOS() ? this.FAILBACK.IOS : this.FAILBACK.ANDROID;
          }

        }, 3000);
        // 当本地app被唤起，则页面会隐藏掉，就会触发pagehide与visibilitychange事件
        // 在部分浏览器中可行，网上提供方案，作hack处理
        let visibilitychange = function () {
          let tag = document.hidden || document.webkitHidden;
          tag && clearTimeout(loadTimer);
        };
        document.addEventListener('visibilitychange', visibilitychange, false);
        document.addEventListener('webkitvisibilitychange', visibilitychange, false);
        // pagehide 必须绑定到window
        window.addEventListener('pagehide', function () {
          clearTimeout(loadTimer);
        }, false);
      },

      changeHTml() {
        this.changeClass = 'fadeOutUpBig';
        this.changeClass1 = 'fadeInUp ff';
      },
      isNum1() {
        //console.log(1)
      },
      getToken() {
        this.$post(this.url + 'token/getToken')
          .then((msg) => {
            this.token = msg.data.data;

          })
      },
      goToZc() {
        this.disabled = true
        this.mid = this.GetQueryStringa('id');
        this.mid=this.mid.replace("#/","");
        this.inviteMid = this.GetQueryStringa('id');
        this.inviteMid=this.inviteMid.replace("#/","");
        /*if (localStorage.getItem('province') === null) {
          alert('无法正常注册,请刷新页面');
          return false;
        }*/
        if (this.subMitToggle) {
          if (this.newPhone === '' ||  !(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.newPhone))){
            alert('请输入正确的手机号');
            this.disabled = false
            return false;
          }
          if (this.yzm === '' || this.yzmReg.test(this.yzm) === false) {
            alert('请输入正确的验证码');
            this.disabled = false
            return false;
          }
//          if (this.mPsd === '' || this.psdReg.test(this.mPsd) === false) {
//            alert('请输入正确格式的密码');
//            return false;
//          }
          //所有验证通过之后。
          this.subMitToggle = false;

//          if(localStorage.getItem('latitude') === '' || localStorage.getItem('latitude') === 'null' || localStorage.getItem('latitude') ===''){}
         /* var latitude,longitude;
          if(localStorage.getItem('latitude') == null || localStorage.getItem('latitude') == null){
            latitude = '37.872905000';
            longitude = '112.518271000';
          }else{
            latitude = localStorage.getItem('latitude');
            longitude = localStorage.getItem('longitude');
          }*/

          //this.$post(this.url + 'member/addMemberzhi', {  //志愿者帮扶
            this.$post(this.url + 'member/register', {      //app邀请
          //this.$post('http://192.168.10.153:8080/warning-web-app/member/addMemberzhi', {
            "phone": this.newPhone,
          //"pswd": this.mPsd,
            "pswd": '',
            'latitude':'00.000000',
            'longitude':'00.000000',
            "province": '',
            "city": '',
            "county": '',
            "inviteMid": this.inviteMid,
            "yzm": this.yzm,
            "mid":this.mid,
            regInterface: 7,
              //regInterface: 5,
              submitToken:this.token,
            shareMid:this.GetQueryStringa('shareMid'),
              shareId:this.GetQueryStringa('value'),
              shareType:this.GetQueryStringa('shareType'),

          }, {
            headers: {'submitToken': this.token}
          })
            .then((msg) => {
              this.getToken();
              this.Details('4')
              this.subMitToggle = true;
              if (msg.data.status) {
                  alert('恭喜您注册成功,请下载登录');
                this.disabled = false
                //document.querySelector('.animated').style.marginTop = -60 + '%';
                let down = document.getElementById('donw-a');
                down.click();
              } else {
                this.disabled = false
                alert(msg.data.msg);
              }
            })
            .catch((err) => {
              this.disabled = false
              alert(err);
              this.subMitToggle = true;
            });
        }

      },
      GetQueryStringa(name)
      {
        var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
        var aaa =  '?'+window.location.hash.split("?")[1]

        var r =aaa.substr(1).match(reg);
        if(r!=null)return  decodeURI(r[2]); return null;
      },
      GetQueryString(param) { //param为要获取的参数名 注:获取不到是为null
        var currentUrl = window.location.href; //获取当前链接
        var arr = currentUrl.split("?");//分割域名和参数界限
        if (arr.length > 1) {
          arr = arr[1].split("&");//分割参数
          for (var i = 0; i < arr.length; i++) {
            var tem = arr[i].split("="); //分割参数名和参数内容
            if (tem[0] == param) {
              return tem[1];
            }
          }
          return null;
        }
        else {
          return null;
        }
      },
      fsYZM() {
        this.Details('2')
        //console.log(this.newPhone.length);
        if (this.newPhone.length < 11) {
          alert('请输入正确的手机号');
          return false;
        }
        if (this.newPhone.length > 11) {
//手机号输入完成之后，验证是否注册过。
          alert('请输入正确的手机号');
          return false;
        }
        if (this.newPhone.length === 11) {
//
            if(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.newPhone)){

            this.$post(this.url + 'member/getPhoneIsExist', {
              phone: this.newPhone
            })
              .then((msg) => {

                if (msg.data.status) {
                  if (msg.data.data.exist) {
                    alert('该手机号已注册,请直接登录');
//this.newPhone = '';
                    this.isSms = true;

                    return false;
                  } else {
//注册
//先发送验证码。然后显示倒计时
//this.getToken()    //发送验证码按钮
                    this.$post(this.url + 'sms/sendSms', {
                      phone: this.newPhone,
                      type: 'reg',
                      token: this.token,
                    }, {
                      headers: {'submitToken': this.token}

                    })
                      .then((msg) => {
                        this.getToken();
                        if (msg.data.status) {
                          this.isSms = false;
                          let time = setInterval(() => {
                            this.count--;
                            if (this.count === 0) {
                              this.isSms = true;
                              clearInterval(time);
                              this.count = 120;
                            }
                          }, 10000)
                        } else {
                          alert(msg.data.msg);
                        }

                      })
                      .catch((err) => {
                      });

                    //console.log(this.isSms);
                  }
                }
                else {
                  alert(msg.data.msg)
                }
              })
          } else {
            alert('请输入正确的手机号');
            this.newPhone = ''
          }
        }

      },
      wxShare() {
        let w = window.location.href.split('#')[0];
        //console.log(w);
        this.$post(this.url + 'weixin/getsign', {
          //uri:encodeURIComponent()
          uri: encodeURIComponent(window.location.href)
        })
          .then((msg) => {

            if (msg.status) {
              this.wxData = msg.data;

              //let config;

              wx.config({
                debug: false,
                appId: this.wxData.appId,
                timestamp: this.wxData.timestamp,
                nonceStr: this.wxData.nonceStr,
                signature: this.wxData.signature,
                jsApiList: [
                  'checkJsApi',
                  'onMenuShareTimeline',
                  'onMenuShareAppMessage',
                  'onMenuShareQQ',
                  'onMenuShareWeibo',
                  'onMenuShareQZone',
                  'hideMenuItems',
                  'showMenuItems',
                  'hideAllNonBaseMenuItem',
                  'showAllNonBaseMenuItem',
                  'translateVoice',
                  'startRecord',
                  'stopRecord',
                  'onVoiceRecordEnd',
                  'playVoice',
                  'onVoicePlayEnd',
                  'pauseVoice',
                  'stopVoice',
                  'uploadVoice',
                  'downloadVoice',
                  'chooseImage',
                  'previewImage',
                  'uploadImage',
                  'downloadImage',
                  'getNetworkType',
                  'openLocation',
                  'getLocation',
                  'hideOptionMenu',
                  'showOptionMenu',
                  'closeWindow',
                  'scanQRCode',
                  'chooseWXPay',
                  'openProductSpecificView',
                  'addCard',
                  'chooseCard',
                  'openCard'
                ]
              });
              wx.ready(() => {
                let uri = window.location.href;
                wx.onMenuShareTimeline({
                  title: this.title, // 分享标题
                  link: uri, // 分享链接，该链接域名必须与当前企业的可信域名一致
                  imgUrl: this.imgUrl, // 分享图标
                  success: function () {
                    // 用户确认分享后执行的回调函数
                  },
                  cancel: function () {
                    // 用户取消分享后执行的回调函数
                  }
                });
                wx.onMenuShareAppMessage({
                  title: this.title, // 分享标题
                  desc: this.desc, // 分享描述
                  link: uri, // 分享链接，该链接域名必须与当前企业的可信域名一致
                  imgUrl: this.imgUrl, // 分享图标

                  success: function () {
                    // 用户确认分享后执行的回调函数
                  },
                  cancel: function () {
                    // 用户取消分享后执行的回调函数
                  }
                });
                wx.onMenuShareQQ({
                  title: this.title, // 分享标题
                  desc: this.desc, // 分享描述
                  link: uri, // 分享链接
                  imgUrl: this.imgUrl, // 分享图标
                  success: function () {
                    // 用户确认分享后执行的回调函数
                  },
                  cancel: function () {
                    // 用户取消分享后执行的回调函数
                  }
                });
                wx.onMenuShareWeibo({
                  title: this.title, // 分享标题
                  desc: this.desc, // 分享描述
                  link: uri, // 分享链接
                  imgUrl: this.imgUrl, // 分享图标
                  success: function () {
                    // 用户确认分享后执行的回调函数
                  },
                  cancel: function () {
                    // 用户取消分享后执行的回调函数
                  }
                });
                wx.onMenuShareQZone({
                  title: this.title, // 分享标题
                  desc: this.desc, // 分享描述
                  link: uri, // 分享链接
                  imgUrl: this.imgUrl, // 分享图标
                  success: function () {
                    // 用户确认分享后执行的回调函数
                  },
                  cancel: function () {
                    // 用户取消分享后执行的回调函数
                  }
                });
              });

            }
          })
      }


    },
    computed: {},
    watch: {
      newPhone(val) {
        if (this.newPhone.length == 11) {
          if(val == ''){
            alert('请输入正确的手机号');
            return false;
          }
          if(/^1(3|4|5|6|7|8|9)\d{9}$/.test(val)){
            //正则验证手机号
            this.Details('2')
            this.$post(this.url + 'member/getPhoneIsExist', {
              phone: this.newPhone
            }).then((msg) => {
                if (msg.data.status) {  //
                  if (msg.data.data.exist) {
//                    this.swiper.slideTo(1, 1000, false);
                    document.querySelector('.w-inp').blur();
                    document.getElementById('www').blur();
                    //document.querySelector('.animated').style.marginTop = -60 + '%';
                    let down = document.getElementById('donw-a');
                    down.click();
                    this.newPhone = '';
                    this.isSms = true;
                    setTimeout(function () {
                      alert('该手机号已注册,请下载登录');
                    }, 150)
                  } else {        //如果没有注册发送验证码
                    this.$post(this.url + 'sms/sendSms', {
                      phone: this.newPhone,
                      type: 'reg', //短信验证码的类型是注册 reg
                      token: this.token,
                    }, {
                      headers: {'submitToken': this.token}

                    })
                      .then((msg) => {
                        this.getToken();//得到新的token

                        if (msg.data.status) {
                          this.isSms = false;  //显示倒计时
                          let time = setInterval(() => {
                            this.count--;
                            if (this.count === 0) {
                              this.isSms = true;
                              clearInterval(time);
                              this.count = 120;
                            }
                          }, 1000)
                        } else {
                          alert(msg.data.msg);
                        }
                      })
                      .catch((err) => {
                      });

                    //console.log(this.isSms);
                  }
                } else {
                  alert(msg.data.msg)
                }


              })
              .catch((err) => {
                alert(err)
              })
          } else {
            alert('请输入正确的手机号');
            this.newPhone = ''
          }
        }
      },

    },
    components: {}
  }
</script>
<style lang="scss">

  //.swiper-slide{ position: absolute!important;}
  .k {
    position: relative;
    width: 100%;
    height: 100%;
    background-color: #fff;
  }

  iframe {
    display: block;
    width: px2rem(750);
    height: px2rem(400);
    margin: 0 auto;
  }

  .ff {
    position: absolute !important;

  }

  .lnviteFrom {
    z-index: 999;
    background-color: #fff;
  }

  /*.wrap {*/
  /*position: absolute;*/
  /*top: 0;*/
  /*left: 0;*/
  /*width: px2rem(750);*/
  /*height: 100%;*/
  /*//overflow-y: scroll;*/
  /*}*/

  .p25 {
    padding: 0 px2rem(25);
  }

  .full {
    //position: fixed;
    width: px2rem(750);
    height: 100%;
    overflow: hidden;

  }

  .logo {
    position: relative;
    z-index: 99999;
    img {
      height: px2rem(470);
      cursor: pointer;
      position: relative;
      z-index: 9999999999;
    }
  }

  input, button {
    outline: none;
  }

  .logo-bottom {
    padding: 0 px2rem(15);
    margin-top: px2rem(20);
  }

  .change-logo {
    width: px2rem(750);
    margin: 0 auto;
    text-align: center;
    margin-top: px2rem(40);
    margin-bottom: px2rem(42);
    img {
      display: inline-block;
    }
  }

  .new-from {
    width: px2rem(610);
    margin: 0 auto;
    //position: relative;
    //z-index: 99999999;
    background-color: #fff;

    p {
      border: px2rem(1) solid #dbdbdb;
      width: 100%;
      height: px2rem(80);
      border-radius: px2rem(10);
      margin-bottom: px2rem(30);
      overflow: hidden;
      .from-icon {
        display: block;
        float: left;
        width: px2rem(80);
        height: 100%;
        img {
          display: block;
          margin: 0 auto;
        }

        .phone {
          width: px2rem(40);
          height: px2rem(50);
          margin-top: px2rem(15);
        }
        .psd {
          width: px2rem(46);
          height: px2rem(46);
          margin-top: px2rem(17);
        }

      }
      input {
        border: none;
        color: #333;
        font-size: px2rem(28);
        height: 100%;
        outline: none;
      }
      .w-inp {
        width: px2rem(480);
      }
      .d-inp {
        width: px2rem(330);
      }
    }
  ;

    .fs-btn {
      width: px2rem(160);
      color: #ff9d00;
      font-size: px2rem(26);
      background-color: transparent;
      border: none;
      line-height: px2rem(70);
      position: relative;
      padding-left: px2rem(25);
      z-index: 99;
    }
    .fs-btn:after {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      border-left: px2rem(1) solid #dbdbdb;

    }

  }

  .next-icon {
    //position: absolute;
    display: block;
    width: px2rem(52);
    height: px2rem(50);
    //left: 50%;
    //margin-left: px2rem(-26);
    //bottom: px2rem(30)
    margin: 0 auto;
    margin-top: px2rem(25);
  }

  .up-data, .down-btn {
    width: 100%;
    height: px2rem(80);
    color: #fff;
    font-size: px2rem(30);
    border: none;
    background-image: -moz-linear-gradient(180deg, rgb(255, 76, 76) 0%, rgb(255, 133, 89) 100%);
    background-image: -webkit-linear-gradient(180deg, rgb(255, 76, 76) 0%, rgb(255, 133, 89) 100%);
    background-image: -ms-linear-gradient(180deg, rgb(255, 76, 76) 0%, rgb(255, 133, 89) 100%);
    background-image: linear-gradient(180deg, rgb(255, 76, 76) 0%, rgb(255, 133, 89) 100%);
    border-radius: px2rem(15);
    //margin-top: px2rem(30);
    position: relative;
  }

  a {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: transparent;
  }

  video {
    display: block;

    width: px2rem(750);
    height: px2rem(420);
    margin: 0 auto;
  }

  .Down {
    background-color: #fff;
    position: relative;
    top: 0;
    left: 0;
  }

  .Down-logo {
    padding: 0 px2rem(25);
    text-align: center;
    height: px2rem(100);
    line-height: px2rem(130);
    margin-top: px2rem(20);

    img {
      display: block;
      float: left;
      width: 50%;

    }
    img:nth-child(1) {
      margin-top: px2rem(25);
    }
  }

  .down-txt {
    padding: px2rem(15) 0;
    color: #999;
    font-size: px2rem(30);
    line-height: px2rem(50);
  }

  .down-txt-img {
    padding: px2rem(15);
    padding-bottom: 0;
    img {
      display: block;
      width: 100%;
    }
  }

  .down-icon {
    position: absolute;
    width: px2rem(60);
    height: px2rem(42);
    top: px2rem(20);
    left: px2rem(47);
    z-index: 99;
    background: url('../../static/down-icon.png') no-repeat;
    -webkit-background-size: cover;
    background-size: cover;
  }

  .logo-two {
    margin-top: px2rem(20);
    margin-bottom: px2rem(20);
  }


</style>
<style>
  #app {
    height: 100%;
  }

  .slider-item > div, .slider1 {
    width: 100%;
    height: 100%;
  }

  html, body {
    position: relative;
    height: 100%;
  }

  body {
    background: #eee;
    font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
    font-size: 14px;
    color: #000;
    margin: 0;
    padding: 0;
  }

  .swiper-container {
    width: 100%;
    height: 100%;
  }

  .swiper-slide {
    text-align: center;
    font-size: 18px;
    background: #fff;

    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
  }
</style>





// WEBPACK FOOTER //
// src/componentsAPP/shareLnvite.vue